import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { IWorkItem } from '../types';

export default function useSubscribeToWorkItem(
  id?: string,
): [IWorkItem | undefined, boolean] {
  const [workItem, setWorkItem] = useState<IWorkItem>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!id) {
      return;
    }

    const workItemRef = doc(db, `workItems/${id}`);

    const unsubscribe = onSnapshot(workItemRef, (doc) => {
      setWorkItem({
        id: doc.id,
        ...doc.data(),
      } as IWorkItem);

      setIsLoading(false);
    });

    return () => unsubscribe();
  }, [id]);

  return [workItem, isLoading];
}
